import React from 'react';
import ContentList from '../../../ContentPage/list';
import useContentListPopupHook from '../../../../../hooks/useContentListPopupHook';
import ActiveCardTile from './ActiveCardTile';
import LastLoginTile from './LastLoginTile';

// Summary row at the top of the statistics tab. FE-1 owns the Active Card tile;
// the Last Login and Login Times tiles (FE-2) render into this same container.
function StatisticsSummaryCards({ userId, excludedWorkspaceIds = [], excludedOrganizationIds = [] }) {
  const { contentGroupPopUp, openContentGroupPopUp, contentListProps } = useContentListPopupHook();

  const handleCardClick = (card) => openContentGroupPopUp({
    content_group_id: card.id,
    workspace_id: card.workspace_id,
  });

  return (
    <>
      <div className="statistics-summary-cards">
        <ActiveCardTile
          userId={userId}
          excludedWorkspaceIds={excludedWorkspaceIds}
          excludedOrganizationIds={excludedOrganizationIds}
          onCardClick={handleCardClick}
        />

        <LastLoginTile
          userId={userId}
          excludedWorkspaceIds={excludedWorkspaceIds}
          excludedOrganizationIds={excludedOrganizationIds}
        />
      </div>

      {contentGroupPopUp.show && (
        <ContentList {...contentListProps} />
      )}
    </>
  );
}

export default StatisticsSummaryCards;
